/* eslint-disable react/destructuring-assignment,react/jsx-no-bind */
import React, { Component } from 'react';
import { connect } from 'dva';
import Copy from "react-copy-to-clipboard";
import { Button, Table, Tooltip, Popconfirm, message, Icon, Modal } from 'antd';
import SelectUser from 'nbugs-select-user-pc';
import OperateDropdown from '../../../../../components/OperateDropdown';
import Container from '../../../../../components/Container';
import { getAppCode } from '../../utils/utils';
import styles from './index.less';
import MyModal from './modal';

@connect(({ columnSetup, user }) => {
  return {
    currentUser: user.currentUser,
    ...columnSetup,
  };
})
class ColumnSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      detail: {},
      loading: false,
      modalVisible: false,
      modalTitle: '添加一级栏目',
      appCode: getAppCode(),
      selectSignature: '',
      showModal: false,
      id: '',
    };
  }

  componentDidMount() {
    this.setColumns();
    this.handleFetchChannelList();
  }

  handleFetchChannelList = () => {
    const { dispatch } = this.props;
    const { appCode } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'columnSetup/fetchChannelList',
      params: { appCode },
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: this.filterData(res),
        });
        // subordinateChannels
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  filterData = data => {
    const arr = [];
    data.forEach(item => {
      if (item.subordinateChannels && item.subordinateChannels.length) {
        arr.push({ ...item, children: item.subordinateChannels });
      } else {
        arr.push(item);
      }
    });
    return arr;
  };

  // 添加 or 修改
  handleFetchChannelAddOrModify = detail => {
    if (!detail) {
      return;
    }
    const isok = !detail.id;
    this.props
      .dispatch({
        type: 'columnSetup/fetchChannelAddOrModify',
        params: { ...detail },
      })
      .then(() => {
        this.setState({ modalVisible: false });
        message.success(isok ? '添加成功！' : '修改成功！');
        this.handleFetchChannelList();
      });
  };

  // 删除
  handleFetchChannelDelete = id => {
    if (!id) {
      return;
    }
    const { appCode } = this.state;
    this.props
      .dispatch({
        type: 'columnSetup/fetchChannelDelete',
        params: { channelid: id, appCode },
      })
      .then(res => {
        message.success(res);
        this.handleFetchChannelList();
      });
  };

  fetchMoveChannel = (record, action) => {
    const { appCode } = this.state;
    const { dispatch } = this.props;
    const { id, orgid } = record;
    dispatch({
      type: 'columnSetup/fetchMoveChannel',
      params: { channelId: id, appCode, orgId: orgid, action },
    }).then(res => {
      message.success(res);
      this.handleFetchChannelList();
    });
  };

  fetchModifyChannelAudit = () => {
    const { id, selectSignature } = this.state;
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'columnSetup/fetchModifyChannelAudit',
      params: { id, selectid: selectSignature, appCode: 1 },
    })
      .then(() => {
        this.setState({ loading: false, showModal: false, selectSignature: '', id: '' });
        message.success('设置审批人成功');
        this.handleFetchChannelList();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleChildNode = (isok, superiorChannelid) => {
    this.setState({
      detail: { superiorChannelid, type: 'add' },
      modalVisible: !0,
      modalTitle: isok ? '新建栏目' : '添加子栏目',
    });
  };

  handleChildNodeEdit = detail => {
    const modalTitle =
      detail.channelTypeName === '一级栏目'
        ? '一级栏目修改'
        : detail.channelTypeName === '二级栏目'
          ? '子栏目修改'
          : '栏目修改';
    this.setState({
      detail: { ...detail, type: 'up' },
      modalTitle,
      modalVisible: !0,
    });
  };

  // 复制活动地址逻辑操作
  handleCopyAddr = (text, result) => {
    if (result) {
      message.success("复制成功");
    } else {
      message.error("复制失败，浏览器不支持");
    }
  };

  // 复制栏目地址
  renderCopyBtn = record => {
    const { id, name } = record;
    return (
      <Copy text={`https://m.xiaoyuanhao.com/micro/app/moralEducationClassroom/modulePageList?appCode=${getAppCode()}&moduleid=${id}&moduleName=${encodeURIComponent(name)}&corpid=`} onCopy={this.handleCopyAddr}>
        <a>复制栏目地址</a>
      </Copy>
    );
  };

  setColumns = () => {
    const columns = [
      {
        title: (
          <div>
            栏目id{'  '}
            <Tooltip placement="top" title="栏目id为系统随机自动生成">
              <Icon type="question-circle" />
            </Tooltip>
          </div>
        ),
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '栏目名称',
        dataIndex: 'name',
        key: 'name',
        render: text => {
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'channelTypeName',
        key: 'channelTypeName',
      },
      {
        title: (
          <div>
            栏目审批人{'  '}
            <Tooltip
              placement="top"
              title="需要审批发布时，可以根据栏目设置不同的审批人员，未设置审批人时默认所有的宣传管理管理员均可审批"
            >
              <Icon type="question-circle" />
            </Tooltip>
          </div>
        ),
        dataIndex: 'audit',
        key: 'audit',
        render: text => {
          if (text && text.length) {
            return (
              <Tooltip
                placement="top"
                title={text.map((item, index) => (
                  <span>
                    {item.username}
                    {index !== text.length - 1 ? '、' : ''}{' '}
                  </span>
                ))}
              >
                <span>{text.length > 1 ? `${text[0].username}...` : text[0].username}</span>
              </Tooltip>
            );
          }
          return <span>-</span>;
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record) => {
          const isok =
            record.channelTypeName !== '一级栏目' && record.channelTypeName !== '二级栏目';
          return record.channelType === '100' ? this.renderCopyBtn(record) : (
            <OperateDropdown data={this.renderAction(record, isok)} />
          );
        },
      },
    ];
    this.setState({ columns });
  };

  renderAction = (record, isok) => {
    const data = [
      {
        text: <a onClick={this.handleChildNodeEdit.bind(this, record)}>修改</a>,
      },
      {
        text: (
          <a
            onClick={() =>
              this.setState({
                showModal: true,
                selectSignature: record.selectid || '',
                id: record.id,
              })
            }
          >
            设置审批人
          </a>
        ),
      },
      {
        text: this.renderCopyBtn(record)
      }
    ];
    if (record.channelTypeName === '一级栏目') {
      data.push({
        text: <a onClick={this.handleChildNode.bind(this, !1, record.id)}>添加子栏目</a>,
      });
    }
    data.push(
      {
        text: <a onClick={this.fetchMoveChannel.bind(this, record, 'up')}>栏目上移</a>,
      },
      {
        text: <a onClick={this.fetchMoveChannel.bind(this, record, 'down')}>栏目下移</a>,
      }
    );
    if (!isok) {
      data.push({
        text: (
          <Popconfirm
            title="确定删除？"
            placement="top"
            onConfirm={this.handleFetchChannelDelete.bind(this, record.id)}
            okText="确定"
            cancelText="取消"
          >
            <a>删除</a>
          </Popconfirm>
        ),
      });
    }
    return data;
  };

  handleCallback = ({ superiorChannelid, name, id, cancel }) => {
    if (cancel) {
      this.setState({ modalVisible: !1 });
      return;
    }
    const { appCode, detail } = this.state;
    const detailParams = { ...detail, superiorChannelid, name, id, appCode };
    this.setState({ detail: detailParams });
    this.handleFetchChannelAddOrModify(detailParams);
  };

  handleSelectUser = ({ selectSignature }) => {
    this.setState({ selectSignature });
  };

  render() {
    const {
      columns,
      loading,
      dataSource,
      modalVisible,
      modalTitle,
      detail,
      showModal,
      selectSignature,
    } = this.state;
    const { currentUser } = this.props;
    const { orgType } = currentUser || {};

    const selectUserProps = {
      appName: '宣传管理',
      appId: 71,
      orgType,
      isShowTagStudent: 0,
      selectType: 'user',
      selectSignature,
      onOk: this.handleSelectUser,
    };

    return (
      <Container breStates={!0} version={2}>
        <div className={styles.root}>
          <section className="create-button">
            <h4>全部栏目</h4>
          </section>
          <section className="create-button">
            <Button
              onClick={this.handleChildNode.bind(this, !0, 0)}
              type="primary"
              className="add-btn"
            >
              新建栏目
            </Button>
          </section>
          <section className="table-area">
            <Table
              rowKey="id"
              columns={columns}
              dataSource={dataSource}
              loading={loading}
              pagination={!1}
              indentSize={30}
            />
          </section>

          <MyModal
            {...detail}
            modalVisible={modalVisible}
            modalTitle={modalTitle}
            callback={this.handleCallback}
          />
          {showModal && (
            <Modal
              title="设置审批人"
              visible={showModal}
              centered
              maskStyle={{ zIndex: 10 }}
              className={styles['modify-form']}
              wrapClassName={styles['wrap-modify-form']}
              onCancel={() => this.setState({ showModal: false, selectSignature: '', id: '' })}
              onOk={this.fetchModifyChannelAudit}
            >
              <SelectUser {...selectUserProps} />
            </Modal>
          )}
        </div>
      </Container>
    );
  }
}

export default ColumnSetup;
